<template>
  <div id="sys_set_main" :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">系统设置</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/发布.png" class="nav-img none" />
      </div>
    </div>

    <ul class="menu-block">

      <li class="ub ub-pc menu-item" @click="goto_DarkModel()">
        <div class="ub-ae ub-f1 font">夜间模式</div>
      </li>
      <div class="menu-line"></div>

      <li class="ub ub-pc menu-item" @click="goto_charge()">
        <div class="ub-ae ub-f1 font">收费设置</div>
      </li>
      <div class="menu-line"></div>

      <li class="ub ub-pc menu-item" @click="goto_Wxnotice()">
        <div class="ub-ae ub-f1 font">通知/音效</div>
      </li>
      <div class="menu-line"></div>

      <li class="ub ub-pc menu-item" @click="goto_rz()">
        <div class="ub-ae ub-f1 font">认证中心</div>
      </li>
      <div class="menu-line"></div>

      <li class="ub ub-pc menu-item" @click="goto_Safe()">
        <div class="ub-ae ub-f1 font">安全中心</div>
      </li>
      <div class="menu-line"></div>

      <li class="ub ub-pc menu-item" @click="goto_Cancel()" v-if="false">
        <div class="ub-ae ub-f1 font">账号注销</div>
      </li>
      <div class="menu-line" v-if="false"></div>

      <li class="ub ub-pc menu-item" @click="goto_user_agreement()">
        <div class="ub-ae ub-f1 font">用户协议</div>
      </li>
      <div class="menu-line"></div>

      <li class="ub ub-pc menu-item" @click="clearCookie()">
        <div class="ub-ae ub-f1 font">清理缓存</div>
      </li>
      <div class="menu-line"></div>

      <li class="ub ub-pc menu-item" @click="seekSys()">
        <div class="ub-ae ub-f1 font">设备检测</div>
      </li>
      <div class="menu-line"></div>

      <li class="ub ub-pc menu-item" @click="goto_DarkRoom()">
        <div class="ub-ae ub-f1 font">小黑屋</div>
      </li>
      <div class="menu-line"></div>

      <li class="ub ub-pc menu-item" v-if="show_voice" @click="goto_Voice()">
        <div class="ub-ae ub-f1 font">语音</div>
      </li>
      <div class="menu-line"></div>
    </ul>
  </div>
</template>

<script>
import * as tool from "../../api/common";
export default {
  data() {
    return {
      data_name: "xxxx",
      uid:"",
      theme_dark: false,
      show_voice: false
    };
  },

  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);

     var uid = this.$store.state.uid;
     this.uid=uid;
     this.init_page();
  },

  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },

    init_page() {
      var sysdic = this.$store.state.sysdic;
      var xhc_admin_uids = sysdic.xhc_admin_uids;
      if(xhc_admin_uids.indexOf(this.uid) !== -1){
          this.show_voice = true;
      }
    },

    goto_rz() {
      this.$router.push({ name: "rz" });
    },
    goto_register() {
      //this.$router.push({ name: "reg" });
    },
    goto_Safe() {
      this.$router.push({ name: "safe" });
    },
    clearCookie() {
      var keys = this.$cookies.keys();
      var count = keys.length;
      for (var i in keys) {
        this.$cookies.remove(keys[i]);
      }
      //保留在线动作、设置积分
      var no_clear_loc = ['loc_online_action', 'loc_set_chatScore', 'loc_set_VoiceScore', 'loc_customize_hello']; // 要保留的loc
      var loc_keys = Object.keys(localStorage);

      loc_keys.forEach(key => {
        if(no_clear_loc.indexOf(key) == -1){
          localStorage.removeItem(key);
        }
      });
      alert("共清理了 " + count + " 项");
    },
    goto_Cancel() {
      this.$router.push({ name: "cancel" });
    },
    goto_DarkRoom(){
      this.$router.push({ name: "dark_room" });
    },
    goto_DarkModel(){
      this.$router.push({ name: "dark_model" });
    },
    goto_Wxnotice(){
      this.$router.push({ name: "wxnotice" });
    },
    goto_test(){
      this.$router.push({ name: "in_test" });
    },
    seekSys(){
       let ua = window.navigator.userAgent;
       alert(ua);
    },
    goto_user_agreement() {
      this.$router.push({ name: "user_agreement" });
    },
    goto_charge() {
      this.$router.push({ name: "charge" });
    },
    goto_Voice() {
      this.$router.push({ name: "admin_voice" });
    }
  },
};
</script>

<style lang="scss" scoped>
.menu-block {
  padding: 0 0.8rem;
  background-color: #fff;
  .menu-item {
    height: 3rem;
    .font {
      font-size: 0.95rem;
    }
  }
  .menu-line {
    border-top: 1px solid #EFEFEF;
  }
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .menu-block {
    background-color: #2c2b30;
    .menu-item {
      .font {
        color: #DFDFDF;
      }
    }
  }
  .menu-line {
    border-top: 1px solid #404040;
  }
}
</style>
